import hyphenDE from 'hyphen/de'
import hyphenEN from 'hyphen/en'
import hyphenFR from 'hyphen/fr'
import hyphenNL from 'hyphen/nl'

export function useHyphen() {
  function hyphen(text: string | undefined) {
    if (!text)
      return ''

    if (import.meta.dev) {
      return text
    }

    const { locale } = useI18n()

    switch (locale.value) {
      case 'en':
        return hyphenEN.hyphenateSync(text)
      case 'de':
        return hyphenDE.hyphenateSync(text)
      case 'fr':
        return hyphenFR.hyphenateSync(text)
      case 'nl':
        return hyphenNL.hyphenateSync(text)
      default:
        console.warn(`No hyphenation for locale ${locale.value}`)
        return text
    }
  }

  return {
    hyphen,
  }
}
